import type { RootState } from 'APP/Store/CreateStore'

const ACCOUNT_LINKING_REQUIRED_STATUSES = ['ask-link', 'force-link', 'suggest-link']

// Account linking should be shown when:
// - the user previously failed to link accounts and the error is still in state
// - the current SSO token says the account must/may be linked before continuing
export const shouldShowAccountLinking = (state: RootState): boolean => {
  const ssoLinkStatus = state.login.customClaims?.sso_link_status
  const accountLinkingError = state.accountLinking.error

  return (
    Boolean(accountLinkingError) || ACCOUNT_LINKING_REQUIRED_STATUSES.includes(ssoLinkStatus ?? '')
  )
}
